import apiClient from './api';

/**
 * Custom fetcher function for Orval-generated API client
 * Uses the apiClient with its interceptors for authentication
 */
export const customFetcher = <T>({
  url,
  method,
  params,
  data,
  headers,
  signal,
}: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: Record<string, any>;
  data?: any;
  headers?: Record<string, string>;
  signal?: AbortSignal;
}): Promise<T> => {
  return apiClient({
    url,
    method,
    params,
    data,
    headers,
    signal,
  }).then((res) => res.data as T);
};
